import * as instagram2fa from './instagram2fa'
import * as instagramArchivePosts from './instagramArchivePosts'
import * as instagramDeleteYourPosts from './instagramDeleteYourPosts'
import * as instagramEmailNotifications from './instagramEmailNotifications'
import {
  getAccountUsernameGatherStageDefs,
  getAdditionalFullGatherStageDefs,
  isAccountDataGathered,
} from './instagramGatherMachine'
import * as instagramHideComments from './instagramHideComments'
import * as instagramHideMessages from './instagramHideMessages'
import * as instagramPrivateAccount from './instagramPrivateAccount'
import * as instagramPushNotifications from './instagramPushNotifications'
import * as instagramStatusVisibility from './instagramStatusVisibility'
import * as instagramStoryReplies from './instagramStoryReplies'
import * as instagramTagging from './instagramTagging'
import * as instagramWhoCanComment from './instagramWhoCanComment'
import { InstagramRecommendationKey } from '../../utils/enums'
import {
  RecommendationAutomationRegistryApi,
  RecommendationAutomationRegistry,
} from '../automationMachineInterfaces'
import * as manualRecommendation from '../manualRecommendation'

const REGISTRY: RecommendationAutomationRegistry = {
  [InstagramRecommendationKey.INSTAGRAM_ADVANCED_COMMENT_FILTERING]: {
    ...manualRecommendation,
    gatherStageDefs: [
      manualRecommendation.generateManualRecommendationGatherStageDef(
        InstagramRecommendationKey.INSTAGRAM_ADVANCED_COMMENT_FILTERING,
      ),
    ],
  },
  [InstagramRecommendationKey.INSTAGRAM_ARCHIVE_POSTS]: instagramArchivePosts,
  [InstagramRecommendationKey.INSTAGRAM_DELETE_YOUR_POSTS]:
    instagramDeleteYourPosts,
  [InstagramRecommendationKey.INSTAGRAM_EMAIL_NOTIFICATIONS_V2]:
    instagramEmailNotifications,
  [InstagramRecommendationKey.INSTAGRAM_HIDE_COMMENTS]: instagramHideComments,
  [InstagramRecommendationKey.INSTAGRAM_HIDE_MESSAGES]: instagramHideMessages,
  [InstagramRecommendationKey.INSTAGRAM_LOCATION_ACCESS]: {
    ...manualRecommendation,
    gatherStageDefs: [
      manualRecommendation.generateManualRecommendationGatherStageDef(
        InstagramRecommendationKey.INSTAGRAM_LOCATION_ACCESS,
      ),
    ],
  },
  [InstagramRecommendationKey.INSTAGRAM_PRIVATE_ACCOUNT]:
    instagramPrivateAccount,
  [InstagramRecommendationKey.INSTAGRAM_PUSH_NOTIFICATIONS]:
    instagramPushNotifications,
  [InstagramRecommendationKey.INSTAGRAM_SETUP_2FA]: instagram2fa,
  [InstagramRecommendationKey.INSTAGRAM_STATUS_VISIBILITY]:
    instagramStatusVisibility,
  [InstagramRecommendationKey.INSTAGRAM_STORY_REPLIES]: instagramStoryReplies,
  [InstagramRecommendationKey.INSTAGRAM_TAGGING]: instagramTagging,
  [InstagramRecommendationKey.INSTAGRAM_UNTAG_PHOTOS]: {
    ...manualRecommendation,
    gatherStageDefs: [
      manualRecommendation.generateManualRecommendationGatherStageDef(
        InstagramRecommendationKey.INSTAGRAM_UNTAG_PHOTOS,
      ),
    ],
  },
  [InstagramRecommendationKey.INSTAGRAM_WHO_CAN_COMMENT]:
    instagramWhoCanComment,
}

export const instagramRegistry: RecommendationAutomationRegistryApi = {
  getAccountUsernameGatherStageDefs: () => getAccountUsernameGatherStageDefs(),
  getAdditionalFullGatherStageDefs: () => getAdditionalFullGatherStageDefs(),
  getRecommendationAutomationRegistry: () => REGISTRY,
  isAccountDataGathered: (accountData) => isAccountDataGathered(accountData),
}
